// app/javascript/controllers/navbar_controller.js
import { Controller } from "@hotwired/stimulus"
import { stimulus } from "../init"


export default class Navbar extends Controller {
  static targets = ["mobileMenu", "mobileMenuOverlay", "userDropdown"]
  static classes = ["hidden", "show"]
  
  connect() {
    this.mobileMenuOpen = false
    this.userDropdownOpen = false
    
    // Close menus when clicking outside or pressing escape
    document.addEventListener('click', this.handleOutsideClick.bind(this))
    document.addEventListener('keydown', this.handleEscapeKey.bind(this))
  }

  disconnect() {
    document.removeEventListener('click', this.handleOutsideClick.bind(this))
    document.removeEventListener('keydown', this.handleEscapeKey.bind(this))
  }

  // Toggle mobile menu
  toggleMobileMenu() {
    this.mobileMenuOpen = !this.mobileMenuOpen
    this.updateMobileMenuDisplay()
  }

  // Open mobile menu
  openMobileMenu() {
    this.mobileMenuOpen = true
    this.updateMobileMenuDisplay()
  }

  // Close mobile menu
  closeMobileMenu() {
    this.mobileMenuOpen = false
    this.updateMobileMenuDisplay()
  }

  // Toggle user dropdown
  toggleUserDropdown() {
    this.userDropdownOpen = !this.userDropdownOpen
    this.updateUserDropdownDisplay()
  }

  // Close user dropdown
  closeUserDropdown() {
    this.userDropdownOpen = false
    this.updateUserDropdownDisplay()
  }

  // Handle clicks outside of menus
  handleOutsideClick(event) {
    // Close mobile menu if clicking on overlay
    if (this.hasMobileMenuOverlayTarget && this.mobileMenuOverlayTarget.contains(event.target)) {
      this.closeMobileMenu()
    }

    // Close user dropdown if clicking outside
    if (this.hasUserDropdownTarget && !this.element.contains(event.target)) {
      this.closeUserDropdown()
    }
  }

  // Handle escape key
  handleEscapeKey(event) {
    if (event.key === 'Escape') {
      this.closeMobileMenu()
      this.closeUserDropdown()
    }
  }

  // Update mobile menu display
  updateMobileMenuDisplay() {
    if (!this.hasMobileMenuTarget) return

    if (this.mobileMenuOpen) {
      // Show mobile menu with animation
      this.mobileMenuTarget.classList.remove('hidden')
      this.mobileMenuOverlayTarget?.classList.remove('hidden')
      
      // Add animation classes
      requestAnimationFrame(() => {
        this.mobileMenuTarget.classList.add('translate-x-0')
        this.mobileMenuTarget.classList.remove('translate-x-full')
        this.mobileMenuOverlayTarget?.classList.add('opacity-100')
        this.mobileMenuOverlayTarget?.classList.remove('opacity-0')
      })
      
      // Prevent body scroll
      document.body.style.overflow = 'hidden'
    } else {
      // Hide mobile menu with animation
      this.mobileMenuTarget.classList.add('translate-x-full')
      this.mobileMenuTarget.classList.remove('translate-x-0')
      this.mobileMenuOverlayTarget?.classList.add('opacity-0')
      this.mobileMenuOverlayTarget?.classList.remove('opacity-100')
      
      // Hide after animation
      setTimeout(() => {
        this.mobileMenuTarget.classList.add('hidden')
        this.mobileMenuOverlayTarget?.classList.add('hidden')
      }, 200)
      
      // Restore body scroll
      document.body.style.overflow = ''
    }
  }

  // Update user dropdown display
  updateUserDropdownDisplay() {
    if (!this.hasUserDropdownTarget) return

    if (this.userDropdownOpen) {
      this.userDropdownTarget.classList.remove('hidden')
      requestAnimationFrame(() => {
        this.userDropdownTarget.classList.add('opacity-100', 'scale-100')
        this.userDropdownTarget.classList.remove('opacity-0', 'scale-95')
      })
    } else {
      this.userDropdownTarget.classList.add('opacity-0', 'scale-95')
      this.userDropdownTarget.classList.remove('opacity-100', 'scale-100')
      setTimeout(() => {
        this.userDropdownTarget.classList.add('hidden')
      }, 75)
    }
  }
}

stimulus.register("navbar", Navbar)